import testUa from './testUa';

const isDuiTang = (): boolean => {
  const r = /(duitang)/gi;
  return testUa(r);
};

export default isDuiTang;
